export default "__VITE_ASSET__e8104dfd__"